import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type { IOtpLoginRequest } from '~/@api/generated-api-types-user/Api'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'

function useAdminOtpLoginMutation() {
  const client = useApiClientUser()

  const {
    mutate: adminOtpLoginMutation,
    isPending: isRequestingAdminOtpLogin,
    error: adminOtpLoginError,
  } = useMutation({
    mutationFn: async (props: IOtpLoginRequest) => {
      return client.user
        .adminOtpControllerOtpLogin(props)
        .then(({ data }) => data)
    },
  })

  return {
    adminOtpLogin: adminOtpLoginMutation,
    isRequestingAdminOtpLogin,
    error: getApiErrorMessage(adminOtpLoginError, 'Prihlásenie sa nepodarilo.'),
  }
}

export { useAdminOtpLoginMutation }
